<template>
  <div id="main-navigation-wrapper" ref="navigation">
    <div
      class="position-fixed overflow-hidden background-overlay d-lg-none"
      @click="closeNavigation"
    ></div>
    <div class="navigation-wrapper px-lg-5">
      <div class="navigation-wrapper-container">
        <div
          class="navigation-header d-flex align-items-center justify-content-between d-lg-none"
        >
          <div class="d-flex align-items-center navigation-header-gap">
            <slot name="language-change"></slot>
            <slot name="showroom-tour"></slot>
          </div>
          <button
            type="button"
            aria-label="Close Navigation"
            class="close-navigation d-flex align-items-center cursor-pointer"
            @click="closeNavigation()"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M15 5L5 15M5 5L15 15"
                stroke="#363636"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
        </div>
        <slot name="my-account"></slot>
        <div
          class="menu-banner-top menu-banner-buttons p-3 d-flex justify-content-between align-items-center overflow-hidden d-lg-none"
        >
          <a
            :href="links.NewHitsLink"
            class="w-100"
            :aria-label="multiLanguage.HeaderNew"
          >
            <button type="button" class="btn btn-new w-100">
              {{ multiLanguage.HeaderNew }}
            </button>
          </a>
          <a
            :href="links.BestSellerLink"
            class="w-100"
            :aria-label="multiLanguage.BestSeller"
          >
            <button type="button" class="btn btn-bestseller w-100">
              {{ multiLanguage.BestSeller }}
            </button>
          </a>
          <a
            :href="links.SaleLink"
            class="w-100"
            :aria-label="multiLanguage.Sale"
          >
            <button type="button" class="btn btn-sale w-100">
              {{ multiLanguage.Sale }}
            </button>
          </a>
        </div>
        <ul
          class="navigation-bar d-flex align-items-center pt-1 justify-content-center"
        >
          <li class="navigation-item">
            <div class="mega-menu-wrapper pl-0">
              <slot name="all-rugs"></slot>
            </div>
          </li>
          <li class="navigation-item">
            <div class="mega-menu-wrapper">
              <div
                class="menu-title font-weight-medium flex-row d-flex align-items-center justify-content"
                @click="setActiveTab('oriental_rugs')"
              >
                <a :href="links.OrientRugs" class="title text-decoration-none">
                  {{ multiLanguage.OrientRugs }}
                </a>
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  class="d-lg-none chevron-icon"
                >
                  <path
                    d="M9 18L15 12L9 6"
                    stroke="#4b5565"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </svg>
              </div>
              <div
                class="mega-menu-container sub-menu-container"
                :class="{ 'menu-active': tabs.oriental_rugs }"
              >
                <oriental-rugs
                  :multi-language="multiLanguage"
                  @close-tab="closeAllTabs"
                  @close-navigation="closeNavigation"
                >
                  <template v-slot:main-oriental-content>
                    <div class="px-3 py-2 d-lg-none">
                      <a
                        :href="links.OrientRugs"
                        class="main-link d-block text-center mb-0 position-relative font-weight-medium text-underline"
                      >
                        {{ multiLanguage.HomepageShowAll }}
                      </a>
                    </div>
                    <slot name="oriental-rugs"></slot>
                  </template>
                </oriental-rugs>
              </div>
            </div>
          </li>
          <li class="navigation-item">
            <div class="mega-menu-wrapper">
              <div
                class="menu-title font-weight-medium flex-row d-flex align-items-center justify-content"
                @click="setActiveTab('modern_rugs')"
              >
                <a :href="links.ModerneRugs" class="title text-decoration-none">
                  {{ multiLanguage.ModerneRugs }}
                </a>

                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  class="d-lg-none chevron-icon"
                >
                  <path
                    d="M9 18L15 12L9 6"
                    stroke="#4b5565"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </svg>
              </div>
              <div
                class="mega-menu-container sub-menu-container"
                :class="{ 'menu-active': tabs.modern_rugs }"
              >
                <modern-rugs
                  :multi-language="multiLanguage"
                  @close-tab="closeAllTabs"
                  @close-navigation="closeNavigation"
                >
                  <template v-slot:main-modern-content>
                    <div class="px-3 py-2 d-lg-none">
                      <a
                        :href="links.ModerneRugs"
                        class="main-link d-block text-center mb-0 position-relative font-weight-medium text-underline"
                      >
                        {{ multiLanguage.HomepageShowAll }}
                      </a>
                    </div>
                    <slot name="modern-rugs"></slot>
                  </template>
                </modern-rugs>
              </div>
            </div>
          </li>
          <li class="navigation-item">
            <div class="mega-menu-wrapper">
              <slot name="woven-rugs"></slot>
            </div>
          </li>
          <li class="navigation-item d-block nav-xl-items">
            <div class="mega-menu-wrapper">
              <slot name="outlet-rugs"></slot>
            </div>
          </li>
          <li class="navigation-item">
            <div class="mega-menu-wrapper pr-0">
              <div
                class="menu-title font-weight-medium sale-title text-white flex-row d-flex align-items-center justify-content px-0"
                @click="setActiveTab('sale')"
              >
                <a
                  :href="links.SaleLink"
                  class="text-white text-decoration-none text-uppercase"
                >
                  {{ multiLanguage.Sale }} %
                </a>
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  class="d-lg-none chevron-icon"
                >
                  <path
                    d="M9 18L15 12L9 6"
                    stroke="#4b5565"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </svg>
              </div>
              <div
                class="mega-menu-container sub-menu-container"
                :class="{ 'menu-active': tabs.sale }"
              >
                <sale
                  :multi-language="multiLanguage"
                  @close-tab="closeAllTabs"
                  @close-navigation="closeNavigation"
                >
                  <template v-slot:main-sale-content>
                    <div class="px-3 py-2 d-lg-none">
                      <a
                        :href="links.SaleLink"
                        class="main-link d-block text-center mb-0 position-relative font-weight-medium text-underline"
                      >
                        {{ multiLanguage.HomepageShowAll }}
                      </a>
                    </div>
                    <slot name="main-sale"></slot>
                  </template>
                </sale>
              </div>
            </div>
          </li>
          <li class="navigation-item">
            <div class="mega-menu-wrapper">
              <slot name="blogs"></slot>
            </div>
          </li>
        </ul>
        <slot name="navigation-footer"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "navigation",
  props: {
    multiLanguage: Object,
    links: Object,
  },
  data() {
    return {
      tabs: {
        modern_rugs: false,
        oriental_rugs: false,
        living_rugs: false,
        size_form: false,
        premium: false,
        sale: false,
      },
    };
  },
  components: {
    "modern-rugs": () => import("./NavigationPartials/ModernRugs.vue"),
    "oriental-rugs": () => import("./NavigationPartials/OrientRugs.vue"),
    "living-rugs": () => import("./NavigationPartials/LivingRooms.vue"),
    "size-form": () => import("./NavigationPartials/SizeForm.vue"),
    premium: () => import("./NavigationPartials/Premium.vue"),
    sale: () => import("./NavigationPartials/Sale.vue"),
  },
  methods: {
    setActiveTab(tab) {
      this.tabs[tab] = !this.tabs[tab];

      if (this.tabs[tab]) {
        for (const key in this.tabs) {
          if (key !== tab) {
            this.tabs[key] = false;
          }
        }
      }
    },
    closeAllTabs() {
      for (const key in this.tabs) {
        this.tabs[key] = false;
      }
    },
    closeNavigation() {
      const navigationWrapper = this.$refs.navigation;
      if (navigationWrapper) {
        navigationWrapper.classList.remove("mobile-active");
        document.querySelector("body").classList.remove("mobile-menu-active");
      }
      this.closeAllTabs();
    },
  },
  mounted() {
    $("#default-navigation-bar").removeClass("d-lg-block");
    $("#custom-navigation-bar").removeClass("d-none");
  },
};
</script>
